
import React from 'react';
import { Flex, Row, Card, Statistic, Button, Modal, Form, InputNumber, Alert, message } from 'antd';
import { HomeOutlined, ShoppingOutlined, } from '@ant-design/icons';
import SwitchShop from '../shop/switch-shop';
import NavItem from '../../components/nav-item';
import { getCurrentShopId } from '../shop/get-current-shop';

const versionMap = {
    1: '基础版',
    2: '专业版',
    3: '连锁版'
}

const iconStyle = {
  fontSize: 28,
}
const cardStyle = {
    flex: 1
}
const Index = () => {
    const [shopId, setShopId] = React.useState(null);
    const [summary, setSummary] = React.useState({});
    const [isOpen, setIsOpen] = React.useState(false);
    const [payOutForm] = Form.useForm();
    const {versionId, wdRate, cwdRate } = window.__baseInfo;
    // 获取店铺信息
    React.useEffect(() => {
        const fetchShopId = async () => {
            const id = await getCurrentShopId();
            setShopId(id);
        };
        
        fetchShopId();
    }, []);
    
    React.useEffect(() => {
        if (shopId) {
            loadShopSummary();
        }
    }, [shopId]);

    const loadShopSummary = async () => {
        getShopSummary(shopId).then(res => {
            setSummary(res.data);
        });
    }

    const getShopSummary = async (shopId) => {
        const res = await fetch(`/api/finance/fund-summary?shopId=${shopId}`);
        const result = await res.json();
        return result;
    }

    const payOut = async () => {
        setIsOpen(true);
    }

    const payOutRequest = async () => {
        const values = await payOutForm.validateFields();
        console.log('values', values);
        const res = await fetch('/api/finance/pay-out', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                shopId,
                amount: values.amount
            })
        });
        const result = await res.json();
        if(result && result.success) {
            message.success('提现成功，请等待到账(2-5个工作日)');
            loadShopSummary();
        }else {
            message.error(result.data);
        }
        setIsOpen(false);
    }

    return (
        <div>
            <SwitchShop />
            <Modal title="提现" open={isOpen} onOk={payOutRequest} onCancel={() => setIsOpen(false)}
                okText="提现" cancelText="取消"
                destroyOnClose={true}
            >

                <Form form={payOutForm} layout="vertical" name="form_in_modal">
                    <Form.Item 
                        label={`提现金额`} 
                        name="amount" 
                        rules={[{ required: true, message: '请输入提现金额' }]}
                        style={{ width: '100%' }}
                    >
                        <InputNumber min={0} max={summary.withdrawAmount/100} autoFocus style={{width: '100%'}} placeholder={`可提现${summary.withdrawAmount/100}元`} />
                    </Form.Item>
                    <Alert message="资金提现后将在5个工作日内到账" type="info" />

                </Form>
            </Modal>
            <Row gap={20} style={{ margin: '10px 0 0 0' }}>
                <NavItem href="/finance/order-flow" text="支付流水">
                    <ShoppingOutlined style={iconStyle} />
                </NavItem>

                <NavItem href="/finance/funding-flow" text="资金流水">
                    <HomeOutlined style={iconStyle} />
                </NavItem>

                <NavItem href={`/shop/create?shopId=${shopId}`} text="银行卡管理">
                    <HomeOutlined style={iconStyle} />
                </NavItem>

                {/* <NavItem href="/" text="提现">
                    <HomeOutlined style={iconStyle} />
                </NavItem> */}
            </Row>

            <Flex gap={10} wrap>
                <Card style={cardStyle}>
                    <Statistic
                        title="余额"
                        value={summary.totalAmount/100}
                        precision={2}
                        valueStyle={{
                            color: '#3f8600',
                        }}
                        // prefix={<ArrowUpOutlined />}
                        // suffix="元"
                    />
                </Card>

                <Card style={cardStyle}>
                    <Statistic
                        title="可提现"
                        value={summary.withdrawAmount/100}
                        precision={2}
                        valueStyle={{
                            color: '#3f8600',
                        }}
                        // prefix={<ArrowUpOutlined />}
                        // suffix={txBtn}
                    />
                </Card>

                <Card style={cardStyle}>
                    <Statistic
                        title="待入账"
                        value={summary.frozenAmount/100}
                        precision={2}
                        valueStyle={{
                            color: '#3f8600',
                        }}
                        // prefix={<ArrowUpOutlined />}
                        // suffix="元"
                    />
                </Card>

                <Card style={cardStyle}>
                    <Statistic
                        title="本月营收"
                        value={summary.monthIncome/100}
                        precision={2}
                        valueStyle={{
                            color: '#3f8600',
                        }}
                        // prefix={<ArrowUpOutlined />}
                        // suffix="元"
                    />
                </Card>
            </Flex>
            {
                <Button type='primary' style={{margin: '10px 0 0 0'}} onClick={payOut} disabled={versionId !== 1}>提现</Button>
            }
            <Alert
                style={{margin: '10px 0 0 0'}}
                title="账户信息"
                description={
                    <div>
                        <div>版本：{versionMap[versionId]}</div>
                        <div>提现费率：{cwdRate * 100}%(<span style={{textDecoration: 'line-through'}}>{wdRate * 100}%</span>)</div>
                        <div>提现方式：{versionId === 1 ? '手动提现': '自动提现'}</div>
                    </div>
                }
                type="info"
            />
        </div>
    )
}

export default Index;